"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegularScheduleSchema = void 0;
const lingo2_models_1 = require("lingo2-models");
const zod_1 = require("zod");
exports.RegularScheduleSchema = zod_1.z.object({
  id: zod_1.z.string().uuid(),
  account_id: zod_1.z.string().uuid(),
  calc_is_active: zod_1.z.boolean().nullable().optional(),
  timezone: zod_1.z.string(),
  weekdays: zod_1.z.array(zod_1.z.object({
    weekday: zod_1.z.nativeEnum(lingo2_models_1.WeekdaysEnum),
    enabled: zod_1.z.boolean(),
    hours: zod_1.z.array(zod_1.z.object({
      id: zod_1.z.string().uuid().optional(),
      begin_hour_at: zod_1.z.number(),
      end_hour_at: zod_1.z.number()
    }))
  })),
  scheduled_to: zod_1.z.date().nullable().optional(),
  signup_gap_hours: zod_1.z.number(),
  max_meeting_signup_days: zod_1.z.number()
});
